window.airSpaceTypes = {
  1: {
    "short": "CTR",
    "en": "Controlled Traffic Region",
    "hu": "Repülőtéri Irányítói Körzet"
  },
  2: {
    "short": "MCTR",
    "en": "Military Controlled Traffic Region",
    "hu": "Katonai Repülőtéri Irányítói Körzet"
  },
  3: {
    "short": "TMA",
    "en": "Terminal Maneuvering Areaközel",
    "hu": "Körzeti Irányítói Körzet"
  },
  4: {
    "short": "MTMA",
    "en": "Military Terminal Maneuvering Area",
    "hu": "Katonai Közelkörzeti Irányítói Körzet"
  },
  5: {
    "short": "CTA",
    "en": "Control Area",
    "hu": "Polgári Irányítói Körzet"
  },
  6: {
    "short": "TIZ",
    "en": "Traffic Information Zone",
    "hu": "Forgalmi Tájékoztató Körzet"
  },
  7: {
    "short": "R",
    "en": "Reserved Airspace",
    "hu": "Korlátozott Légtér"
  },
  8: {
    "short": "TRA",
    "en": "Temporarily Reserved Airspace",
    "hu": "Időszakosan Korlátozott Légtér"
  },
  9: {
    "short": "DZ",
    "en": "Drop Zone",
    "hu": "Ejtőernyős Légtér"
  },
  10: {
    "short": "NPA",
    "en": "Nature Protection Airspace",
    "hu": "Környezetvédelmi Légtér"
  },
  11: {
    "short": "LHD",
    "en": "Large Height Deviation",
    "hu": "Nagy Magassági Eltérés"
  },
  12: {
    "short": "Eseti",
    "en": "Temporary Airspace",
    "hu": "Eseti Légtér"
  },
  13: {
    "short": "P",
    "en": "Prohibited Airspace",
    "hu": "Tiltott Légtér"
  },
  14: {
    "short": "G",
    "en": "Glider Airspace",
    "hu": "Vitorlázó Légtér"
  },
  15: {
    "short": "A",
    "en": "Aerobatics Airspace",
    "hu": "Műrepülő Légtér"
  },
  16: {
    "short": "MilOp",
    "en": "Military Border Defence Airspace",
    "hu": "Katonai Határsávi Műveleti Légtér"
  },
  17: {
    "short": "RMZ",
    "en": "Radio Mandatory Zone",
    "hu": "Rádió Kötelező Körzet"
  },
  18: {
    "short": "TMZ",
    "en": "Transponder Mandatory Zone",
    "hu": "Válaszjeladó Kötelező Körzet"
  },
  19: {
    "short": "G/C",
    "en": "Coordinated Glider Airspace",
    "hu": "Koordinált Vitorlázó Légtér"
  },
  100: {
    "short": "LHP",
    "en": "Airspace Protected",
    "hu": "Tiltott Légtér"
  },
  101: {
    "short": "LHR",
    "en": "Airspace Restricted",
    "hu": "Korlátozott Légtér"
  },
  200: {
    "short": "Airport",
    "en": "Airport",
    "hu": "Repülőtér"
  },
  300: {
    "short": "User",
    "en": "User",
    "hu": "Felhasználó"
  }
}
